import React, { useEffect, useRef, useState } from 'react';
import Modal from 'components/shared/Modal/Modal';
import { RoleConfigScaffold } from '../RoleConfigScaffold/RoleConfigScaffold';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import './RoleConfigModal.css';
import DebounceInput from 'react-debounce-input';
import { doRoleCreate, doRoleUpdate } from 'redux/actions';
import { useDispatch } from 'react-redux';
import SvgAF from '../../../shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

export const RoleConfigModal = (props) => {
  const [editRoleName, setEditRoleName] = useState('');
  const [selectionDict, setSelectionDict] = useState(null);
  const [renderKey, setRenderKey] = useState(0);
  const editRoleDesc = useRef('');

  const editModes = {
    NEW: 'NEW',
    UPDATE: 'UPDATE',
    READONLY: 'READONLY'
  };

  useEffect(() => {
    if (props.editMode === editModes.NEW) setSelectionDict({});
    else if (props.currRoleData?.permissions) {
      setSelectionDict(props.currRoleData?.permissions);
    }
  }, []);

  const dispatch = useDispatch();

  const handlePermissionSelection = (service, perm) => {
    let currSelectionDict = selectionDict;

    let found = false;

    if (currSelectionDict[service] == null) currSelectionDict[service] = [perm.name];
    else {
      currSelectionDict[service].forEach((p, index) => {
        if (perm.name === p) {
          found = true;

          if (currSelectionDict[service].length === 1) {
            delete currSelectionDict[service];
          } else currSelectionDict[service].splice(index, 1);
        }
      });

      if (!found) currSelectionDict[service].push(perm.name);
    }

    setRenderKey(renderKey + 1);
  };

  return (
    <div className="RoleConfigModal">
      <Modal width={1200} height={850} close={() => props.sendRoleConfigModalMode(null)}>
        <div className="RoleConfigModal_Header">
          <div className="RoleConfigModal_Header_Text">Role detail</div>
          <div className="RoleConfigModal_Header_Icon">
            {props.editMode === editModes.READONLY && props.sourcePage == null && (
              <SvgAF
                img={IconLoader.icon_edit_detail}
                hover={IconLoader.icon_edit_detail_hover}
                onClick={() => {
                  props.sendRoleConfigModalMode(editModes.UPDATE);
                }}
              />
            )}
          </div>
        </div>
        <div className="RoleConfigModal_NameSection">
          <div className="RoleConfigModal_NameSection_Title">Name of the role</div>
          <DebounceInput
            disabled={props.editMode === editModes.READONLY}
            type="text"
            className="RoleConfigModal_NameSection_Input"
            debounceTimeout={200}
            value={props.currRoleData?.role}
            onChange={(event) => {
              setEditRoleName(event.target.value);
            }}
          />
        </div>
        <div className="RoleConfigModal_DescriptionSection">
          <div className="RoleConfigModal_DescriptionSection_Title">Description</div>
          <textarea
            className="RoleConfigModal_DescriptionSection_Input"
            disabled={props.editMode === editModes.READONLY}
            cols="40"
            rows="2"
            onChange={(event) => {
              editRoleDesc.current = event.target.value;
            }}
          >
            {props.currRoleData?.description}
          </textarea>
        </div>
        <div className="RoleConfigModal_PermissionSection">
          <div className="RoleConfigModal_PermissionSection_Title">Select permissions</div>

          <div className="RoleConfigModal_PermissionSection_Content">
            <PerfectScrollbar>
              <div className="RoleConfigModal_PermissionSection_Content_Pane">
                {props.allServicePermissions.map((sp) => (
                  <RoleConfigScaffold
                    selectedPerms={props.currRoleData != null && props.currRoleData?.permissions?.[sp.serviceId]}
                    singleServicePermissions={sp}
                    selectionFunc={(service, permissions) => handlePermissionSelection(service, permissions)}
                    editMode={props.editMode !== editModes.READONLY} // || localEditMode}
                  />
                ))}
              </div>
            </PerfectScrollbar>
          </div>
          {props.editMode !== editModes.READONLY && (
            <div className="RoleConfigModal_PermissionSection_Footer">
              <button
                className="RoleConfigModal_PermissionSection_Footer_cancelButton Global_CancelButton"
                onClick={() => props.sendRoleConfigModalMode(null)}
              >
                Cancel
              </button>

              <button
                className="RoleConfigModal_PermissionSection_Footer_saveButton Global_ApplyButton"
                disabled={
                  (selectionDict != null && Object.keys(selectionDict).length === 0) ||
                  (props.editMode === editModes.NEW && editRoleName == '')
                }
                onClick={() => {
                  props.editMode === editModes.NEW &&
                    dispatch(
                      doRoleCreate(
                        editRoleName,
                        editRoleDesc.current,
                        selectionDict,
                        (result) => {
                          props.triggerRefresh();
                        },
                        (error) => {
                          props.transmitError(error);
                        }
                      )
                    );
                  props.editMode === editModes.UPDATE &&
                    dispatch(
                      doRoleUpdate(
                        props.currRoleData._id,
                        editRoleDesc.current,
                        selectionDict,
                        (result) => {
                          props.triggerRefresh();
                        },
                        (error) => {
                          props.transmitError(error);
                        }
                      )
                    );

                  props.sendRoleConfigModalMode(null);
                }}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
